import React, { useContext } from "react";

//material ui
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import JSONPretty from "react-json-pretty";

//styling
import "./querySchemaModal.scss";

//global state
import { StateContext } from "../../AppStateContext";

const DisplayQuerySchemaModal = ({ isQuerySchemaModalOpen, setIsQuerySchemaModalOpen, schema }) => {
  const handleClose = () => {
    setIsQuerySchemaModalOpen(false);
  };

  //global state
  const state = useContext(StateContext);

  //to close the modal
  const closeModal = () => {
    setIsQuerySchemaModalOpen(false);
  };

  return (
    <>
      <Modal
        disableScrollLock
        aria-labelledby="Query schema modal"
        aria-describedby="Visualize the query schema"
        open={isQuerySchemaModalOpen}
        className="__querySchemaModalOuter"
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isQuerySchemaModalOpen}>
          <div
            className={
              state.theme === "dark"
                ? "__querySchemaModal __querySchemaModalDark"
                : "__querySchemaModal __querySchemaModalLight"
            }
          >
            <h2>Schema</h2>
            <JSONPretty
              id="jquery-schema-json-pretty"
              className="__query-pretty-json"
              data={schema}
              themeClassName="__query-pretty-json"
              theme={{
                main: "line-height:1.3;color:#b0a002;background:transparent;overflow:auto;",
                error: "line-height:1.3;color:#b0a002;background:transparent;overflow:auto;",
                key: "color:#fa0171;",
                string: "color:#38d611;",
                value: "color:#b04802;",
                boolean: "color:#f17c3b;",
              }}
            ></JSONPretty>
            <br />
            <button onClick={closeModal}>Close</button>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default DisplayQuerySchemaModal;
